import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// This file is autogenerated. Any changes will be overwritten in next build.

const Account = props => {
  const {
    size,
    color
  } = props;
  const sizeMap = {
    sm: 20,
    md: 24,
    lg: 28
  };
  let sizeValue = size;
  if (typeof size === 'number') {
    sizeValue = size;
  } else if (typeof size === 'string') {
    sizeValue = sizeMap[size];
  }
  return /*#__PURE__*/_jsxs("svg", {
    width: sizeValue,
    height: sizeValue,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "4.33333",
      y: "4.33333",
      width: "15.3333",
      height: "15.3333",
      rx: "3",
      stroke: color,
      strokeWidth: "0.666667"
    }), /*#__PURE__*/_jsx("line", {
      x1: "4.33325",
      y1: "14.3334",
      x2: "19.6666",
      y2: "14.3334",
      stroke: color,
      strokeWidth: "0.666667"
    }), /*#__PURE__*/_jsx("rect", {
      x: "9.00008",
      y: "16.3333",
      width: "6",
      height: "1.33333",
      rx: "0.333333",
      fill: color,
      stroke: color,
      strokeWidth: "0.666667"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15.1068 14.2001L9 14.2002C9 11.2464 10.7393 11.0001 11.8333 11.0001C14.4402 10.8333 14.97 12.354 15.1068 14.2001Z",
      stroke: color,
      strokeWidth: "0.666667"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "12",
      cy: "9",
      r: "2",
      stroke: color,
      strokeWidth: "0.666667"
    })]
  });
};
export { Account };